// filepath: d:\Culture OS (FrontEnd And Backend)\FrontEndNew\company-ui\src\Screens\NotFound\NotFound.js
import React from 'react';
import { Button, Stack, Typography } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import { Avatar } from '@mui/material'; // <-- use MUI Avatar
import notFoundImg from '../../Assets/Image/404.svg';
import { AppColors } from '../../Utils/helper/AppColors';
export default function NotFound() {
	const navigate = useNavigate();


	return (
		<Stack
			minHeight={'100vh'}
			display={'flex'}
			justifyContent={'center'}
			alignItems="center"
			// justifyContent="center"
			spacing={2}
			p={2}
		>
			<Stack sx={{
				
				display: 'flex',
				justifyContent: 'center',
				alignItems: 'center',
			}} spacing={2}>
				<Avatar src={notFoundImg} alt="Not Found" sx={{ width: 1000, height: 522, borderRadius: 0 }} />
				<Typography sx={{ fontSize: 17, fontFamily: 'Rubic', fontWeight: 600, lineHeight: '34px', color: '#565872' }}>
					Opps! Page Not Found
				</Typography>

				<Button variant="contained" color="info" sx={{ borderRadius: '4px' }} mt={2} onClick={() => navigate('/')}>
					Back To Home
				</Button>
			</Stack>
		</Stack>
	);
}
